import { combineReducers } from 'redux'

import actions from 'actions'
import paginate from './paginate'

const pagination = combineReducers({
  eventGroupPerformances: paginate(actions.ENTITIES_EVENT_GROUP_PERFORMANCES, action => action.eventGroupId),
  eventGroupPastPerformances: paginate(actions.ENTITIES_EVENT_GROUP_PAST_PERFORMANCES, action => action.eventGroupId),
  partnerPastEventGroups: paginate(actions.ENTITIES_EVENT_GROUPS, action => action.partnerId),
})

export default pagination



/** WEBPACK FOOTER **
 ** ./src/reducers/pagination/pagination.js
 **/